export var SIMPLE_DIE_ROLL = '_SimpleDieRoll';
var simpleDieRoll = {
    regex: /\d+d\d+/,
    typeConstant: SIMPLE_DIE_ROLL,
    tokenize: function (raw) {
        var _a = raw.split('d').map(function (num) { return parseInt(num); }), count = _a[0], numSides = _a[1];
        return { count: count, numSides: numSides };
    },
    roll: function (_a, _b) {
        var count = _a.count, numSides = _a.numSides;
        var generateRolls = _b.generateRolls;
        return generateRolls(count, numSides);
    },
    calculateValue: function (token, rolls) { return rolls.reduce(function (agg, num) { return agg + num; }, 0); },
};
export default simpleDieRoll;
